import { OnInit } from '@angular/core';
import { MatDialogRef, MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
var ModalUserComponent = /** @class */ (function () {
    function ModalUserComponent(dialogRef, data, formBuilder, snackBar) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.formBuilder = formBuilder;
        this.snackBar = snackBar;
    }
    ModalUserComponent.prototype.cancel = function () {
        this.dialogRef.close('cancel');
    };
    ModalUserComponent.prototype.submit = function () {
        if (!this.formGroup.valid) {
            this.snackBar.open('Preencha corretamente o campo e tente novamente.');
            return false;
        }
        this.dialogRef.close(this.formGroup.value.email);
    };
    ModalUserComponent.prototype.ngOnInit = function () {
        this.formGroup = this.formBuilder.group({
            email: [null, [Validators.required, Validators.email]],
        });
    };
    return ModalUserComponent;
}());
export { ModalUserComponent };
